<!--
    变更记录
 -->
<template>
    <div class="change-all">
        <div class="change-box">
            <!-- <div v-for="(item,index) in arrChange" class="change-left-box"
                :style="{background: (index % 2 == 0 ? '#fff':'#F9F9FB')}">
                <div class="change-title"
                    :style="{lineHeight : (item.title.length < 4 ? '31px':''),padding:(item.title.length > 6 ? '15px 10px' : '15px 18px')}">
                    {{item.title}}
                </div>
                <div class="change-design"
                    :style="{color : (item.title == '施工图' ? '#0D53FC' :item.title == '装修 效果图' ? '#0D53FC':item.title == '预算 配置单' ? '#0D53FC' : item.title == '方案 编号' ? '#000000':'#555555'),
                        fontWeight : (item.title == '方案 编号' ? '600':''),
                        textDecoration:(item.title == '施工图' ? 'underline' :item.title == '装修 效果图' ? 'underline':item.title == '预算 配置单' ? 'underline':'')}">
                    <div :class="item.title == '审核 状态' ?'change-btn':''">{{item.design}}</div>
                </div>
                <div class="change-change" :style="{color: (item.title == '方案 类型' ? '#555555' : item.title == '审核 状态' ? '#FFF' : item.change == '-' ? '#555555' : item.change == '暂无' ? '#555555':'#E95859'),
                    textDecoration:(item.title == '施工图' ? 'underline' :item.title == '装修 效果图' ? 'underline':item.title == '预算 配置单' ? 'underline':''),
                    fontWeight:(item.title == '方案 类型' ? '600':'400')}">
                    <div :class="item.title == '审核 状态' ?'change-btn':''">{{item.change}}</div>
                </div>
            </div> -->

            <!-- detail1 是当前方案   detail2为原设计方案 -->

            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">方案<br/>类型</div>
                <div class="change-design">设计方案</div>
                <div class="change-change-title">变更方案</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">审核<br/>状态</div>
                <div class="change-design-button">{{arrChangeInfo.detail2.status_txt!== null ? arrChangeInfo.detail2.status_txt : '暂无'}}</div>
                <div class="change-design-button" v-if="arrChangeInfo.detail1.status_txt !== null">{{arrChangeInfo.detail1.status_txt}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">方案<br/>编号</div>
                <div class="change-design fontwite">{{arrChangeInfo.detail2.new_name!== null ? arrChangeInfo.detail2.new_name : '暂无'}}</div>
                <div class="change-change fontwite" v-if="arrChangeInfo.detail1.new_name !== null">{{arrChangeInfo.detail1.new_name}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">锅炉<br/>台数</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_boilernumber!== null ? arrChangeInfo.detail2.new_boilernumber : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_boilernumber !== null">{{arrChangeInfo.detail1.new_boilernumber}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">地暖<br/>面积</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_area!== null ? arrChangeInfo.detail2.new_area : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_area !== null">{{arrChangeInfo.detail1.new_area}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">暖气片组数</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_group!== null ? arrChangeInfo.detail2.new_group : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_group !== null">{{arrChangeInfo.detail1.new_group}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">风机盘管组数</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_fancoilgroup!== null ? arrChangeInfo.detail2.new_fancoilgroup : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_fancoilgroup !== null">{{arrChangeInfo.detail1.new_fancoilgroup}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">市政供暖对接</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_isgovernment!== null ? arrChangeInfo.detail2.new_isgovernment : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_isgovernment !== null">{{arrChangeInfo.detail1.new_isgovernment}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title" style="padding: 15px 10px;">室外机安装空间</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_installspace!== null ? arrChangeInfo.detail2.new_installspace : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_installspace !== null">{{arrChangeInfo.detail1.new_installspace}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title" style="padding: 15px 10px;">室外机安装形式</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_installstyle!== null ? arrChangeInfo.detail2.new_installstyle : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_installstyle !== null">{{arrChangeInfo.detail1.new_installstyle}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">地暖 套餐</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_floorheatpackage!== null ? arrChangeInfo.detail2.new_floorheatpackage : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_floorheatpackage !== null">{{arrChangeInfo.detail1.new_floorheatpackage}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">锅炉 型号</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_boilermodel!== null ? arrChangeInfo.detail2.new_boilermodel : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_boilermodel !== null">{{arrChangeInfo.detail1.new_boilermodel}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">暖气片类型</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_radiatortype!== null ? arrChangeInfo.detail2.new_radiatortype : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_radiatortype !== null">{{arrChangeInfo.detail1.new_radiatortype}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">延米</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_extendedmeter !== null ? arrChangeInfo.detail2.new_extendedmeter : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_extendedmeter !== null">{{arrChangeInfo.detail1.new_extendedmeter}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">新风机型号</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_freshairmodel!== null ? arrChangeInfo.detail2.new_freshairmodel : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_freshairmodel !== null">{{arrChangeInfo.detail1.new_freshairmodel}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">新风主机台数</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_freshairnumber!== null ? arrChangeInfo.detail2.new_freshairnumber : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_freshairnumber !== null">{{arrChangeInfo.detail1.new_freshairnumber}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">分风箱型号</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_airboxmodel!== null ? arrChangeInfo.detail2.new_airboxmodel : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_airboxmodel !== null">{{arrChangeInfo.detail1.new_airboxmodel}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">送风口数量</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_supplyairnumber !== null ? arrChangeInfo.detail2.new_supplyairnumber : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_supplyairnumber !== null">{{arrChangeInfo.detail1.new_supplyairnumber}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">回风口数量</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_returnairnumber !== null ? arrChangeInfo.detail2.new_returnairnumber : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_returnairnumber !== null">{{arrChangeInfo.detail1.new_returnairnumber}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">施工图</div>
                <div class="change-design" style="textDecoration:underline;color: #0D53FC;display: flex;align-items: center;justify-content: center;"
                    v-if="arrChangeInfo.detail2.shigong.length > 0">
                    <div>
                        <div @click="clickEncl(arrChangeInfo.detail2.shigong)">附件</div>
                        <div v-for="(item,index) in designShigong" :key="index" style="margin-top: 18px;" @click="getPDF(item.path)">文件{{index + 1}}</div>
                    </div>
                </div>
                <div class="change-change" v-else>-</div>
                <div class="change-change" style="textDecoration:underline;color: #E95859;display: flex;align-items: center;justify-content: center;"
                    v-if="arrChangeInfo.detail1.shigong.length > 0">
                    <div>
                        <div @click="clickEncl(arrChangeInfo.detail1.shigong)">附件</div>
                        <div v-for="(item,index) in changeShigong" :key="index" style="margin-top: 18px;" @click="getPDF(item.path)">文件{{index + 1}}</div>
                    </div>
                </div>
                <div class="change-change" v-else>-</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">装修 效果图</div>
                <div class="change-design" style="textDecoration:underline;color: #0D53FC;display: flex;align-items: center;justify-content: center;"
                    v-if="arrChangeInfo.detail2.zhuangxiu.length > 0">
                    <div>
                        <div @click="clickEncl(arrChangeInfo.detail2.zhuangxiu)">附件</div>
                        <div v-for="(item,index) in designZhuangxiu" :key="index" style="margin-top: 18px;" @click="getPDF(item.path)">文件{{index + 1}}</div>
                    </div>
                </div>
                <div class="change-change" v-else>-</div>
                <div class="change-change" style="textDecoration:underline;color: #E95859;display: flex;align-items: center;justify-content: center;"
                    v-if="arrChangeInfo.detail1.zhuangxiu.length > 0">
                    <div>
                        <div @click="clickEncl(arrChangeInfo.detail1.zhuangxiu)">附件</div>
                        <div v-for="(item,index) in changeZhuangxiu" :key="index" style="margin-top: 18px;" @click="getPDF(item.path)">文件{{index + 1}}</div>
                    </div>
                </div>
                <div class="change-change" v-else>-</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">预算 配置单</div>
                <div class="change-design" style="textDecoration:underline;color: #0D53FC;display: flex;align-items: center;justify-content: center;"
                    v-if="arrChangeInfo.detail2.yusuan.length > 0">
                    <div>
                        <div @click="clickEncl(arrChangeInfo.detail2.yusuan)">附件</div>
                        <div v-for="(item,index) in designYusuan" :key="index" style="margin-top: 18px;" @click="getPDF(item.path)">文件{{index + 1}}</div>
                    </div>
                </div>
                <div class="change-change" v-else>-</div>
                <div class="change-change" style="textDecoration:underline;color: #E95859;display: flex;align-items: center;justify-content: center;"
                    v-if="arrChangeInfo.detail1.yusuan.length > 0">
                    <div>
                        <div @click="clickEncl(arrChangeInfo.detail1.yusuan)">附件</div>
                        <div v-for="(item,index) in changeYusuan" :key="index" style="margin-top: 18px;" @click="getPDF(item.path)">文件{{index + 1}}</div>
                    </div>
                </div>
                <div class="change-change" v-else>-</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">变更 时间</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_submit_time ? arrChangeInfo.detail2.new_submit_time : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_submit_time !== null">{{arrChangeInfo.detail1.new_submit_time}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                <div class="change-title">审批 时间</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_approved_time ? arrChangeInfo.detail2.new_approved_time : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_approved_time !== null">{{arrChangeInfo.detail1.new_approved_time}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
            <div class="change-left-box" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                <div class="change-title">备注</div>
                <div class="change-design">{{arrChangeInfo.detail2.new_memo ? arrChangeInfo.detail2.new_memo : '暂无'}}</div>
                <div class="change-change" v-if="arrChangeInfo.detail1.new_memo !== null">{{arrChangeInfo.detail1.new_memo}}</div>
                <div class="change-design" v-else>暂无</div>
            </div>
        </div>
        <!-- <div class="mask">
            <div v-for="(item,index) in arrImg" :key="index">
                <img :preview='index' :src="item" />
            </div>
        </div> -->
        <!-- 预览图片 -->
        <van-image-preview v-model="imgShow" :startPosition="lookImgIndex" :closeable="true" @close="close" :images="arrImg"></van-image-preview>

        <img class="back_icon" @click="touchBack" src="~@/assets/images/archives/dossier/back_icon.png" />
    </div>
</template>

<script>
    import progTaber from '../dossier/components/prog_taber/index.vue';
    import oData from '@/js/archives/survey/index.js'
    export default {
        components: {
            progTaber,
        },
        data() {
            return {
                arrChange: [{
                        title: '方案 类型',
                        design: '设计方案',
                        change: '变更方案'
                    },
                    {
                        title: '审核 状态',
                        design: '已审批',
                        change: '已审批'
                    },
                    {
                        title: '方案 编号',
                        design: 'BG202204210001',
                        change: 'BG202204210001'
                    },
                    {
                        title: '锅炉 台数',
                        design: '128',
                        change: '108'
                    },
                    {
                        title: '地暖 面积',
                        design: '36',
                        change: '-'
                    },
                    {
                        title: '暖气片组数',
                        design: '7',
                        change: '8'
                    },
                    {
                        title: '风机盘管组数',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '市政供暖对接',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '室外机安装空间',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '室外机安装形式',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '地暖 套餐',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '锅炉 型号',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '暖气片类型',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '延米',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '新风机型号',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '新风主机台数',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '分封箱型号',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '送风口数量',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '回风口数量',
                        design: '是',
                        change: '-'
                    },
                    {
                        title: '施工图',
                        design: '附件',
                        change: '-'
                    },
                    {
                        title: '装修 效果图',
                        design: '附件',
                        change: '附件'
                    },
                    {
                        title: '预算 配置单',
                        design: '附件',
                        change: '-'
                    },
                    {
                        title: '变更 时间',
                        design: '暂无',
                        change: '2022.04.22'
                    },
                    {
                        title: '审批 时间',
                        design: '2022.04.11',
                        change: '2022.04.11'
                    },
                    {
                        title: '备注',
                        design: '暂无',
                        change: '暂无'
                    }
                ],
                project_id: '',
                projectdesign_id: '',
                arrChangeInfo: {
                    detail1: {},
                    detail2: {}
                },
                arrImg: [],
                imgShow:false,
                lookImgIndex: 0,
                designShigong: [],
                changeShigong: [],
                designZhuangxiu: [],
                changeZhuangxiu: [],
                designYusuan: [],
                changeYusuan: [],
            }
        },
        created() {
            this.project_id = this.$route.query.id
            this.projectdesign_id = this.$route.query.prog
            console.log(this.project_id)
            console.log(this.projectdesign_id)
            this.getChange()
        },
        methods: {
            getChange() {
                this.$store.commit("loadSwitch", true);
                oData.projectChange({
                    type: 1,
                    project_id: this.project_id,
                    projectdesign_id: this.projectdesign_id
                }).then(res => {
                    this.$store.commit("loadSwitch", false);
                    this.arrChangeInfo = res.data.data.result
                    let arr = res.data.data.result
                    //施工
                    this.designShigong = arr.detail2.shigong.map(it =>{
                        return it
                    }).filter(im =>{ if(im.type > 0){ return im } })

                    this.changeShigong = arr.detail1.shigong.map(it =>{
                        return it
                    }).filter(im =>{ if(im.type > 0){ return im } })
                    //装修
                    this.designZhuangxiu = arr.detail2.shigong.map(it =>{
                        return it
                    }).filter(im =>{ if(im.type > 0){ return im } })

                    this.changeZhuangxiu = arr.detail1.shigong.map(it =>{
                        return it
                    }).filter(im =>{ if(im.type > 0){ return im } })
                    //预算
                    this.designYusuan = arr.detail2.shigong.map(it =>{
                        return it
                    }).filter(im =>{ if(im.type > 0){ return im } })

                    this.changeYusuan = arr.detail1.shigong.map(it =>{
                        return it
                    }).filter(im =>{ if(im.type > 0){ return im } })

                    console.log(this.changeShigong);
                })
            },
            clickEncl(arr) {
                console.log(arr,'+++');
                this.imgShow = true
                this.$previewRefresh()
                let arrList = []
                arr.forEach(it =>{
                    if(it.type == 0){
                        arrList.push(it.path)
                    }
                })
                console.log(arrList,'----');
                this.arrImg = arrList
            },
            //PDF,excle预览
            getPDF(url){
                window.location.href = url
            },
            close(){
                setTimeout(() =>{
                    this.arrImg = []
                    console.log(this.arrImg)
                },500)
            },
            touchBack(){
                this.$router.back()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fontwite{
        font-weight: 600;
    }
    .mask{
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
    .change-all {
        width: 100%;
        background: #F9F9FB;
        height: 100vh;
        padding: 32px 0;

        .change-box {
            margin: 0 auto;
            // margin: 32px 0;
            // padding-bottom: 32px 0 ;
            width: 686px;
            background: #FFFFFF;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.0500);
            border-radius: 16px 16px 16px 16px;

            .change-left-box {
                // background: #FFFFFF;
                display: flex;

                &:nth-child(1) {
                    border-radius: 16px 16px 0 0;
                }

                &:last-child {
                    border-radius: 0 0 16px 16px;
                }

                .change-title {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 142px;
                    text-align: center;
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    border-right: 2px solid rgba(238, 238, 238, 0.6);
                    padding: 30px 32px;
                    // margin: 0 auto;
                }
                .change-change-title{
                    width: 270px;
                    padding: 48px 0 46px 0;
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    color: #555555;
                    text-align: center;
                }
                .change-design-button{
                    width: 128px;
                    height: 40px;
                    background: #74B176;
                    border-radius: 106px 106px 106px 106px;
                    text-align: center;
                    line-height: 42px;
                    margin: auto;
                    color: #FFF;
                }

                .change-design {
                    width: 270px;
                    padding: 48px 0 46px 0;
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    // font-weight: 400;
                    color: #555555;
                    text-align: center;

                    &:nth-child(5) {
                        color: #f80404;
                    }
                }

                .change-change {
                    width: 270px;
                    padding: 48px 0 46px 0;
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    color: #E95859;
                    text-align: center;
                }

                .change-btn {
                    width: 128px;
                    height: 40px;
                    background: #74B176;
                    border-radius: 106px 106px 106px 106px;
                    text-align: center;
                    line-height: 40px;
                    margin: 0 auto;
                    color: #FFF;
                }
            }
        }
        .back_icon{
            position: fixed;
            left: 32px;
            bottom: calc(env(safe-area-inset-bottom) + 150px);
            z-index: 999;
            width: 100px;
            height: 100px;
        }
    }
</style>
